import React, { useEffect, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { DairyRequirementFilter } from '../../components/Filter/DairyRequirementFilter.js';
import axios from 'axios';
import { baseUrl, formatDateDMY, roundQty, cratesToQty } from '../../comman/config';
import Select from 'react-select';
import Loader from "../../components/Loader.js";
import NoRecordsFound from "../../components/NoRecordsFound.js";
import { useNavigate } from 'react-router-dom';
import IngredientBatchModel from '../../components/IngredientBatchModel.js';
import { menuAboveTable } from "../../comman/selectMenu";


function DairyReceiptList() {
  const [ingredientReceiptList, setIngredientReceiptList] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [receiptStatus, setReceiptStatus] = useState([]);
  const [ingredient, setIngredient] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [loading, setLoading] = useState(false)
  const [noRecordsFound, setNoRecordsFound] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [itemIngedientList, setItemIngredientList] = useState(null);
  const [ingredientsListForStdQty, setIngredientsListForStdQty] = useState([])
  const navigate = useNavigate();

  useEffect(() => {
    getIngredientReceiptList();
  }, [])

  useEffect(() => {
    console.log(ingredientReceiptList)
    getIngredientList()
    getIngredientListForStdQty()
  }, [ingredientReceiptList])

  const handelFilterChange = async (from_date, to_date, order_status, order_id, ingredient, receipt_status) => {
    setFromDate(from_date);
    setToDate(to_date);
    setIngredient(ingredient || []);
    setReceiptStatus(receipt_status || []);
    // Fetch with the values Submit handed over. Submitting an untouched filter re-sets the state to
    // what it already held, so a list that only reloaded on a state change would sit there.
    getIngredientReceiptList({ from_date, to_date, ingredient: ingredient || [], receipt_status: receipt_status || [] });
  };

  const getIngredientList = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const existingIngredientIds = ingredientReceiptList.map(item => item.ingredient_id);
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 2 && !existingIngredientIds.includes(item.id));
    setIngredientList(list);
  };

  const getIngredientListForStdQty = async () => {
    const response = await axios.get(`${baseUrl}/ingredients/list?limit=all`);
    const list = response.data.data.filter((item) => item.status == 1 && item?.store?.id == 2);
    setIngredientsListForStdQty(list);
  };
  const getIngredientReceiptList = async (filters) => {
    const { from_date, to_date, ingredient: filterIngredient, receipt_status } = filters ?? {
      from_date: fromDate,
      to_date: toDate,
      ingredient: ingredient,
      receipt_status: receiptStatus
    };

    setLoading(true)
    setNoRecordsFound(false)

    // Prepare receipt status values
    let statusValues = [];

    // If receipt_status contains the "All" option (value 0), don't include any status filter
    if (Array.isArray(receipt_status) && receipt_status.length > 0) {
      if (receipt_status.some(item => item.value === 0)) {
        // Don't set any status values - this will show all statuses
        statusValues = null;
      } else {
        // Extract the values from the array of objects
        statusValues = receipt_status.map(item => item.value);
      }
    } else if (receipt_status?.value) {
      // Single select case
      statusValues = [receipt_status.value];
    }


    const response = await axios.post(`${baseUrl}/dairy_receipt/list`,
      {
        from_date: from_date,
        to_date: to_date,
        ingredient: filterIngredient?.value,
        receipt_status: statusValues

      });

    const updatedArray = response?.data?.data.map(item => ({
      ...item,         // Spread existing properties
      rec_crates_qty: item.rec_crates_qty ?? 0,
      received_qty: item.received_qty ?? "",
      crates_qty: item.crates_qty ?? 0,
      order_qty: item.order_qty ?? 0,
      // Both are one float subtracted from another, and both are read as quantities on screen.
      diff_crates: roundQty(item.rec_crates_qty - item.total_crates, 2),
      diff_qty: roundQty(item.received_qty - item.total_order),
      std_qty_per_crate: item.std_qty_per_crate ?? 0,
      add_received: false,
    }));
    setIngredientReceiptList(updatedArray);
    setNoRecordsFound(updatedArray.length === 0);
    setLoading(false)
  }

  const displayIngredientDetail = async (e, item) => {
    e.preventDefault();
    setLoading(true)

    const RecipeDbData = await axios.get(`${baseUrl}/dairy_receipt/ingredient_details`, {
      params: {
        order_id: item.order_id,
        ingredient_id: item.ingredient_id
      }
    });
    const ingredientsList = RecipeDbData.data.data;

    setItemIngredientList(ingredientsList);
    setLoading(false)
    setShowModal(true);
  }
  // Packs is what was received counted in theli: the crates entered times the packets a crate
  // holds. Read-only, and blank rather than 0 while the ingredient has no
  // Std. Qty. per Crate - Theli / Packets.
  const packsFor = (item) => cratesToQty(item?.rec_crates_qty, Number(item?.std_qty_per_crate_theli) || 0);

  const handleToggleSelect = (index) => {
    const updatedSelectedRows = selectedRows.includes(ingredientReceiptList[index])
      ? selectedRows.filter(item => item !== ingredientReceiptList[index]) // Deselect
      : [...selectedRows, ingredientReceiptList[index]]; // Select

    setSelectedRows(updatedSelectedRows);
  };

  const handleSwitchSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(ingredientReceiptList.filter((item) => item.receipt_status == 1)); // Select all rows
    }
    setSelectAll(!selectAll);
  };

  const handleInputChange = (index) => (e) => {
    const { name, value } = e.target;

    setIngredientReceiptList((prevFormData) => {
      if (name === 'rec_crates_qty') {
        const updatedFormData = [...prevFormData];
        const crates_qty = updatedFormData[index].total_crates;
        const diff_crates = (value - crates_qty).toFixed(2);
        if (!updatedFormData[index].std_qty_per_crate) {
          const addStdQtyPrompt = window.confirm(
            // `Standard quantity per crate is missing for ${updatedFormData[index].ingredient}. Would you like to add it now?`
            `${updatedFormData[index].ingredient} માટે સ્ટાન્ડર્ડ માત્રા પ્રતિ ક્રેટ ખૂટી છે. તમે તેને હમણાં ઉમેરવા માંગો છો?`
          );

          if (addStdQtyPrompt) {
            // Extract ingredient_id from the object
            const ingredientId = updatedFormData[index]?.ingredient_id;

            if (ingredientId) {
              console.log("id:", ingredientId);
              editIngredient(ingredientId); // Pass ingredient_id correctly
            }
          }
          return prevFormData; // Prevent updating the state
        }

        const received_qty = value ? roundQty(value * updatedFormData[index].std_qty_per_crate) : 0;
        const diff_qty = (received_qty - updatedFormData[index].total_order).toFixed(2);
        updatedFormData[index] = { ...updatedFormData[index], [name]: value, diff_crates: diff_crates, diff_qty: diff_qty, received_qty: received_qty };
        return updatedFormData;
      }
    });
  };

  const editIngredient = async (id) => {
    navigate(`/ingredients_receipt/edit/${btoa(id)}`, {
      state: ingredientsListForStdQty.filter(item => item.id == id)
    });
  };
  const handleSave = async () => {
    try {
      const response = await axios.post(`${baseUrl}/dairy_receipt/save`,
        {
          ingredientsList: ingredientReceiptList
        });
      toast.success("Data save successfully.");
      getIngredientReceiptList();
    } catch (error) {
      toast.error("Failed to add item. Please try again.");
    }
    // }
  }

  const clearItem = () => {
    setSelectedRows([]);
    setItemIngredientList(null);
    getIngredientReceiptList();
  };

  const handleSubmit = async () => {
    if (selectedRows.length == 0) {
      alert("Please select at least one row");
      setSelectedRows([]);
      return;
    }
    console.log(selectedRows);
    if (selectedRows.some(item => item.received_qty === "")) {
      alert("One or more items have an empty recieved qty value.");
      setSelectedRows([]);
      return;
    }
    if (selectedRows.some(item => item.add_received_qty === "")) {
      alert("One or more items have an empty additional recieved qty value.");
      setSelectedRows([]);
      return;
    }
    if (selectedRows.some(item => item.ingredient_id === null)) {
      alert("One or more items have an empty ingredient value.");
      setSelectedRows([])
      return
    }
    if (selectedRows.length > 0) {
      try {
        setLoading(true);
        const response = await axios.post(`${baseUrl}/dairy_receipt/dairy_purchase`,
          {
            ingredientsList: selectedRows
          });
        console.log("response:", response.data.data)
        const msg = response.data.msg;

        await getIngredientReceiptList();

        toast.success(msg);

      } catch (error) {
        toast.error("Failed to add item. Please try again.");
      } finally {
        setLoading(false); // Hide loading state
      }
    }
    setSelectedRows([])
  };

  const handleAddNewIngredientRow = () => {
    setIngredientReceiptList([...ingredientReceiptList, {
      ingredient: '',
      ingredient_obj: {},
      ingredient_id: null,
      std_qty_per_crate: 0,
      rec_crates_qty: '',
      received_qty: '',
      order_qty: 0,
      crates_qty: 0,
      total_order:0,
      total_crates:0,
      diff_crates: 0,
      diff_qty: 0,
      purchase_status: 1,
      receipt_status: 1,
      isNew: true
    }]);
  };

  const handleNewIngredientChange = (selectedOptions, index) => {
    console.log("selected option:", selectedOptions)
    const updatedList = [...ingredientReceiptList]
    updatedList[index].ingredient_obj = selectedOptions
    updatedList[index].ingredient = selectedOptions.ingredient
    updatedList[index].ingredient_id = selectedOptions.value
    updatedList[index].std_qty_per_crate = selectedOptions.std_qty_per_crate
    updatedList[index].std_qty_per_crate_theli = selectedOptions.std_qty_per_crate_theli
    setIngredientReceiptList(updatedList)
  }

  return (
    <div className="p-4">
      {loading && <Loader />}
      <div className="flex justify-between items-center py-4 px-6">
        <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">
          Receipt
        </h1>
        <Toaster position="top-center" reverseOrder={false} />
      </div>
      <div className="relative shadow-md sm:rounded-lg">
        <DairyRequirementFilter handleFilterChange={handelFilterChange} page="receipt" />
      </div>
      {noRecordsFound && <NoRecordsFound />}

      {ingredientReceiptList.length > 0 && (
        <>
          {/* Desktop Table View */}
          <div className="hidden lg:block overflow-x-auto">
            <table className="w-full mt-10 text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-2 py-1 border border-black text-center " rowSpan="2">
                    <input type="checkbox" className="newrow checkboxAll" onChange={handleSwitchSelectAll} checked={selectAll} />
                  </th>
                  <th scope="col" className="px-2 py-1 border border-black text-center " rowSpan="2">Ingredient</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center " rowSpan="2">Meal Date</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center" colSpan='3'>Received Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center" colSpan='2'>Order qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center " colSpan='2'>Diff Qty</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center " rowSpan="2">Receipt Status</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center " rowSpan="2">Order No.</th>
                </tr>
                <tr>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Crates</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Liters/kgs.</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Packs</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Crates</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Liters/kgs</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Crates</th>
                  <th scope="col" className="px-2 py-1 border border-black text-center ">Liters/kgs</th>
                </tr>
              </thead>
              <tbody>
                {ingredientReceiptList.map((item, index) => (
                  <tr key={index} className="border border-black-b">
                    <td className="px-2 py-1 border border-black text-center">
                      <input type="checkbox" checked={selectedRows.includes(item)} onChange={() => handleToggleSelect(index)} />
                    </td>
                    <td className="px-2 py-1 border border-black text-center">
                      {item.isNew ? (
                        <Select
                          {...menuAboveTable}
                          classNamePrefix="select"
                          className='basic-multi-select'
                          value={item.ingredient_obj}
                          name="ingredient"
                          onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                          options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            unit: item.unit?.id,
                            ingredient: `${item.ingredient}`,
                            eng_name: item.eng_name,
                            std_qty_per_crate: item.std_qty_per_crate,
                            std_qty_per_crate_theli: item.std_qty_per_crate_theli,
                          }))}
                          placeholder="Ingredient List"
                          filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                        />
                      ) : (item.ingredient)}
                    </td>
                    <td className="px-2 py-1 border border-black text-center">{formatDateDMY(item.date)}</td>
                    <td className="px-0 py-1 border border-black text-center">
                      <input type="number"
                        id="rec_crates_qty"
                        name="rec_crates_qty"
                        value={item?.rec_crates_qty ?? ''}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange(index)}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className="px-2 py-1 border rounded-md w-20 bg-orange-50"
                      />
                    </td>
                    <td className="px-2 py-1 border border-black text-center">{item?.received_qty ?? ''}</td>
                    <td className="px-2 py-1 border border-black text-center bg-gray-100">{packsFor(item)}</td>
                    <td className="px-2 py-1 border border-black text-center">{item.total_crates}</td>
                    <td className="px-2 py-1 border border-black text-center">{item.total_order}</td>
                    <td className={`px-2 py-1 border border-black text-center ${item.diff_crates < 0 ? 'bg-red-400 text-white' : ''}`}>{item.diff_crates}</td>
                    <td className={`px-2 py-1 border border-black text-center ${item.diff_qty < 0 ? 'bg-red-400 text-white' : ''}`}>{item.diff_qty}</td>
                    <td
                      className={`px-2 py-1 border border-black text-center 
                      ${item.receipt_status === 1 ? "text-red-500" :
                          item.receipt_status === 2 ? "text-orange-500" :
                            "text-black"}`}
                    >
                      {item.receipt_status === 1 ? "Pending Receipt" :
                        item.receipt_status === 2 ? "Partly Received" :
                          item.receipt_status === 3 ? "Received" :
                            item.receipt_status === 4 ? "Excess Received" :
                              "All"}
                    </td>
                    <td className="px-2 py-1 border border-black text-center text-blue-500 underline cursor-pointer">
                      <a
                        href="#"
                        className="underline text-blue-500"
                        onClick={(e) => displayIngredientDetail(e, item)}
                      >
                        {item.order_id}
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Card View */}
          <div className="lg:hidden mt-6 space-y-4">
            {/* Select All Card */}
            <div className="bg-gray-50 p-4 rounded-lg border">
              <label className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  className="newrow checkboxAll"
                  onChange={handleSwitchSelectAll}
                  checked={selectAll}
                />
                <span className="text-sm font-medium">Select All</span>
              </label>
            </div>

            {/* Item Cards */}
            {ingredientReceiptList.map((item, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                {/* Header with checkbox and ingredient name */}
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center space-x-3">
                    <input
                      type="checkbox"
                      checked={selectedRows.includes(item)}
                      onChange={() => handleToggleSelect(index)}
                      className="mt-1"
                    />
                    <div className="flex-1">
                      {item.isNew ? (
                        <Select
                          {...menuAboveTable}
                          classNamePrefix="select"
                          className='basic-multi-select'
                          value={item.ingredient_obj}
                          name="ingredient"
                          onChange={(selectedOptions) => handleNewIngredientChange(selectedOptions, index)}
                          options={ingredientList.map((item) => ({
                            value: item.id,
                            label: `${item.ingredient} (${item.eng_name})`,
                            unit: item.unit?.id,
                            ingredient: `${item.ingredient}`,
                            eng_name: item.eng_name,
                            std_qty_per_crate: item.std_qty_per_crate,
                            std_qty_per_crate_theli: item.std_qty_per_crate_theli,
                          }))}
                          placeholder="Select Ingredient"
                          filterOption={(option, inputValue) => {
                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                        />
                      ) : (
                        <div>
                          <h3 className="font-semibold text-gray-900">{item.ingredient}</h3>
                          <p className="text-sm text-gray-500">{formatDateDMY(item.date)}</p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="text-right">
                    <span className={`inline-block px-2 py-1 rounded-full text-xs font-medium ${item.receipt_status === 1 ? 'bg-red-100 text-red-800' :
                        item.receipt_status === 2 ? 'bg-orange-100 text-orange-800' :
                          item.receipt_status === 3 ? 'bg-green-100 text-green-800' :
                            item.receipt_status === 4 ? 'bg-blue-100 text-blue-800' :
                              'bg-gray-100 text-gray-800'
                      }`}>
                      {item.receipt_status === 1 ? "Pending Receipt" :
                        item.receipt_status === 2 ? "Partly Received" :
                          item.receipt_status === 3 ? "Received" :
                            item.receipt_status === 4 ? "Excess Received" :
                              "All"}
                    </span>
                  </div>
                </div>

                {/* Received Quantity Section */}
                <div className="mb-4">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Received Quantity</h4>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="text-xs font-medium text-gray-600">Crates</label>
                      <input
                        type="number"
                        id="rec_crates_qty"
                        name="rec_crates_qty"
                        value={item?.rec_crates_qty ?? ''}
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange(index)}
                        onKeyDown={(e) => {
                          if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                            e.preventDefault();
                          }
                        }}
                        className="mt-1 w-full px-2 py-1 border rounded-md text-sm bg-orange-50"
                      />
                    </div>
                    <div>
                      <label className="text-xs font-medium text-gray-600">Liters/Kgs</label>
                      <div className="mt-1 px-2 py-1 bg-gray-50 rounded text-sm font-medium">
                        {item?.received_qty ?? ''}
                      </div>
                    </div>
                    <div>
                      <label className="text-xs font-medium text-gray-600">Packs</label>
                      <div className="mt-1 px-2 py-1 bg-gray-50 rounded text-sm font-medium">
                        {packsFor(item)}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Order Quantity Section */}
                <div className="mb-4">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Order Quantity</h4>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="text-xs font-medium text-gray-600">Crates</label>
                      <div className="mt-1 px-2 py-1 bg-gray-50 rounded text-sm font-medium">
                        {item.total_crates}
                      </div>
                    </div>
                    <div>
                      <label className="text-xs font-medium text-gray-600">Liters/Kgs</label>
                      <div className="mt-1 px-2 py-1 bg-gray-50 rounded text-sm font-medium">
                        {item.total_order}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Difference Section */}
                <div className="mb-4">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Difference</h4>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="text-xs font-medium text-gray-600">Crates</label>
                      <div className={`mt-1 px-2 py-1 rounded text-sm font-medium ${item.diff_crates < 0 ? 'bg-red-100 text-red-800' : 'bg-gray-50 text-gray-800'
                        }`}>
                        {item.diff_crates}
                      </div>
                    </div>
                    <div>
                      <label className="text-xs font-medium text-gray-600">Liters/Kgs</label>
                      <div className={`mt-1 px-2 py-1 rounded text-sm font-medium ${item.diff_qty < 0 ? 'bg-red-100 text-red-800' : 'bg-gray-50 text-gray-800'
                        }`}>
                        {item.diff_qty}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Order ID */}
                <div className="border-t pt-3">
                  <label className="text-xs font-medium text-gray-600">Order No.</label>
                  <div className="mt-1">
                    <a
                      href="#"
                      className="text-blue-500 underline text-sm"
                      onClick={(e) => displayIngredientDetail(e, item)}
                    >
                      {item.order_id}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <IngredientBatchModel
            showModal={showModal}
            setShowModal={setShowModal}
            detailList={itemIngedientList}
            clearItem={clearItem}
            page="dairy_receipt_list"
            type={4}
          />

          <div className='m-5 space-y-2 sm:space-y-0 sm:space-x-4 sm:flex'>
            <button
              onClick={handleAddNewIngredientRow}
              className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Add Ingredient
            </button>
            <button
              onClick={handleSave}
              className="w-full sm:w-auto px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
            >
              Save
            </button>
            <button
              onClick={handleSubmit}
              className="w-full sm:w-auto px-4 py-2 bg-rose-500 text-white rounded-md hover:bg-rose-600 focus:outline-none focus:ring focus:ring-rose-200"
            >
              Received
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default DairyReceiptList;